






import { Component, Vue } from 'vue-property-decorator';
import Referendum from './Referendum.vue';

@Component({
  components: {
    Referendum,
  },
})
export default class Referendums extends Vue {
  private referendums: any[] = [];

  public mounted() {
    this.loadReferendas();
  }

  public async loadReferendas() {
    if ((this as any).$http.api) {
      const referendums = await (this as any).$http.api.derive.democracy.referendums();
      this.referendums = referendums;
      
    }
  }  

}
